import { render, staticRenderFns } from "./previewZJXX.vue?vue&type=template&id=9f19daa2&scoped=true&"
import script from "./previewZJXX.vue?vue&type=script&lang=js&"
export * from "./previewZJXX.vue?vue&type=script&lang=js&"
import style0 from "./previewZJXX.vue?vue&type=style&index=0&id=9f19daa2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f19daa2",
  null
  
)

export default component.exports